module.exports = __webpack_public_path__ + "img/educationalStages.14ea86c3.svg";